import { NewsletterSignupView } from "@/components/website-builder/NewsletterSignupView"
import type { BlockComponentProps } from "./shared"

export function NewsletterSignupBlock({ content, org, resolved, sectionId }: BlockComponentProps) {
  const nh = (content?.heading as string) ?? ""
  const nb = (content?.body as string) ?? ""
  const nCta = (content?.cta_text as string) ?? "Subscribe"
  const nPlaceholder = (content?.placeholder as string) ?? "Enter your email"
  const nsSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-8"} ${resolved.cornerClass} ${resolved.alignClass || "text-center"} max-w-xl mx-auto`.trim()
    : "px-4 py-8 @sm:px-6 @md:px-8 max-w-xl mx-auto text-center"
  const nsPrimaryColor = "var(--nos-color-primary, #3b82f6)"
  return (
    <section className={nsSectionClass} style={resolved.sectionStyle}>
      {org?.id ? (
        <NewsletterSignupView
          orgId={org.id}
          sectionId={sectionId}
          heading={nh || undefined}
          body={nb || undefined}
          ctaText={nCta}
          placeholder={nPlaceholder}
          primaryColor={nsPrimaryColor}
        />
      ) : (
        <>
          {nh && <h2 className="text-2xl font-bold mb-2">{nh}</h2>}
          {nb && <p className="text-muted-foreground text-sm mb-4">{nb}</p>}
          <div className="flex gap-2">
            <input
              type="email"
              placeholder={nPlaceholder}
              className="flex-1 rounded-lg border px-4 py-2"
              readOnly
              disabled
            />
            <button type="button" className="px-4 py-2 rounded-lg bg-muted font-medium" disabled>
              {nCta}
            </button>
          </div>
          <p className="text-xs text-muted-foreground mt-2">Newsletter signup (configure in website builder)</p>
        </>
      )}
    </section>
  )
}
